<template>
  <a-modal
      :title="$t('MAP')"
      :visible="modalVisible"
      :footer="null"
      @cancel="this.toggleMap">
    <yandex-map
        style="width:100%; height: 400px"
        :coords="latlong"
        :zoom="10">
      <ymap-marker
          :coords="latlong"
          marker-id="123"/>
    </yandex-map>
  </a-modal>
</template>

<script>
import {mapActions} from "vuex";
import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: 'MapModal',
  components: {
    yandexMap, ymapMarker
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.$store.state.app.mapModal.visible
      }
    },
    latlong: {
      get: function () {
        return this.$store.state.app.mapModal.latlong
      }
    }
  },
  methods: {
    ...mapActions({
      toggleMapModal: 'toggleMapModal'
    }),

    toggleMap() {
      this.toggleMapModal([0,0])
    }
  }
}
</script>

<style>

</style>
